export class UrlConstants {
  static DOWNLOAD_FILE: string;
  static UPDATEAPIKEYSTATUS: string;
  static DELETECHATBOT(DELETECHATBOT: any, formData: FormData, arg2: { headers: { Authorization: string; }; }) {
    throw new Error('Method not implemented.');
  }
  static DELETECUSTOMERDATA(DELETECUSTOMERDATA: any, fd: FormData, arg2: { headers: { Authorization: string; }; }) {
    throw new Error('Method not implemented.');
  }
  static DELETEAPIKEY(DELETEAPIKEY: any, formData: FormData, arg2: { headers: { Authorization: string; }; }) {
    throw new Error('Method not implemented.');
  }
  static GENERATESCRIPT(GENERATESCRIPT: any, requestBody: { user_id: any; chatbot_id: any; chatbot_name: any; theme: any; userName: any; }, arg2: { headers: { 'Content-Type': string; Authorization: string; }; }) {
    throw new Error('Method not implemented.');
  }
  static TESTBOT(TESTBOT: any, requestBody: { user_id: any; chatbot_id: string; message: string; session_id: string; }, arg2: { headers: { 'Content-Type': string; Authorization: string; }; }) {
    throw new Error('Method not implemented.');
  }
  // static CURRENTDOMAINURL = "https://prpsms.biz";
  //LOCAL
  // static MBS_APIACCOUNTMASTER = 'https://localhost:44330/api/';
  // static MBS_APISMSMASTER = 'https://localhost:44330/api/';
  // static MBS_APITRANSACTION = 'https://localhost:44330/api/';
  // static MBS_IMGPATH = 'https://localhost:44330';

  //RCS Prod
  //  static MBS_APIACCOUNTMASTER = 'http://43.204.222.58:8082/api/';
  // static MBS_APISMSMASTER = 'http://43.204.222.58:8082/api/';
  // static MBS_APITRANSACTION = 'http://43.204.222.58:8082/api/';
  // static MBS_IMGPATH = 'http://43.204.222.58:8082';


  //RCS Testing

  //  static MBS_APIACCOUNTMASTER = 'http://161.97.169.18:8086/api/';
  // static MBS_APISMSMASTER = 'http://161.97.169.18:8086/api/';
  // static MBS_APITRANSACTION = 'http://161.97.169.18:8086/api/';
  // static MBS_IMGPATH = 'http://161.97.169.18:8086';

//  static MBS_APIACCOUNTMASTER = 'http://139.5.190.30:8087/api/';
//   static MBS_APISMSMASTER = 'http://139.5.190.30:8087/api/';             //Production server
//   static MBS_APITRANSACTION = 'http://139.5.190.30:8087/api/';           // Change this for Testing
//   static MBS_IMGPATH = 'http://139.5.190.30';


  // static MBS_APIACCOUNTMASTER = 'http://139.5.190.30:8084/api/';
  // static MBS_APISMSMASTER = 'http://139.5.190.30:8084/api/';            
  // static MBS_APITRANSACTION = 'http://139.5.190.30:8084/api/';           // Change this for Testing
  // static MBS_IMGPATH = 'http://139.5.190.30';
  // static DYNAMICBOT = 'http://156.67.25.89:5005';

  
  // static MBS_APIACCOUNTMASTER = 'https://testaiapi.chatmybot.in/api/';
  // static MBS_APISMSMASTER = 'https://testaiapi.chatmybot.in/api/';            
  // static MBS_APITRANSACTION = 'https://testaiapi.chatmybot.in/api/';    // Currently Change this for Testing Linux Testing
  // static MBS_IMGPATH = 'https://testaiapi.chatmybot.in';

  static MBS_APIACCOUNTMASTER = 'https://aiapi.chatmybot.in/api/';
  static MBS_APISMSMASTER = 'https://aiapi.chatmybot.in/api/';
  static MBS_APITRANSACTION = 'https://aiapi.chatmybot.in/api/';           //  Change this for LIVE
  static MBS_IMGPATH = 'https://aiapi.chatmybot.in';


  // static MBS_APIACCOUNTMASTER = 'http://139.5.190.30:9095/api/';
  // static MBS_APISMSMASTER = 'http://139.5.190.30:9095/api/';
  // static MBS_APITRANSACTION = 'http://139.5.190.30:9095/api/';          //uncomment this when u face any problem.
  // static MBS_IMGPATH = 'http://139.5.190.30:9095';



  // static MBS_APIACCOUNTMASTER = 'http://161.97.169.18.8085/api/';
  // static MBS_APISMSMASTER = 'http://161.97.169.18.8085/api/';
  // static MBS_APITRANSACTION = 'http://161.97.169.18.8085/api/';
  // static MBS_IMGPATH = 'http://161.97.169.18.8085';

  //smpp testing
  //  static MBS_APIACCOUNTMASTER = 'http://139.5.190.30:8081/api/';
  // static MBS_APISMSMASTER = 'http://139.5.190.30:8081/api/';
  // static MBS_APITRANSACTION = 'http://139.5.190.30:8081/api/';
  // static MBS_IMGPATH = 'http://139.5.190.30';

  //rcsLive

  // static MBS_APIACCOUNTMASTER = 'https://apirbm.prpsms.biz/api/';
  // static MBS_APISMSMASTER = 'https://apirbm.prpsms.biz/api/';
  // static MBS_APITRANSACTION = 'https://apirbm.prpsms.biz/api/';
  // static MBS_IMGPATH = 'https://apirbm.prpsms.biz';

  // static MBS_APIACCOUNTMASTER = 'http://139.5.190.30:8082/api/';
  // static MBS_APISMSMASTER = 'http://http://139.5.190.30:8082/api/';
  // static MBS_APITRANSACTION = 'http://http://139.5.190.30:8082/api/';
  // static MBS_IMGPATH = 'http://http://139.5.190.30:8082';

  //TEST
  // static MBS_APIACCOUNTMASTER = 'http://161.97.169.18:8081/api/';
  // static MBS_APISMSMASTER = 'http://161.97.169.18:8081/api/';
  // static MBS_APITRANSACTION = 'http://161.97.169.18:8081/api/';
  // static MBS_IMGPATH = 'http://161.97.169.18:8081';

  //LIVE
  //  static MBS_APIACCOUNTMASTER = 'http://164.52.196.49:8091/api/';
  //  static MBS_APISMSMASTER = 'http://164.52.196.49:8091/api/';
  //  static MBS_APITRANSACTION = 'http://164.52.196.49:8091/api/';
  //  static MBS_IMGPATH = 'http://164.52.196.49:8091';
  //  static MBS_APIACCOUNTMASTER = 'https://api.prpsms.biz/api/';
  //  static MBS_APISMSMASTER = 'https://api.prpsms.biz/api/';
  //  static MBS_APITRANSACTION = 'https://api.prpsms.biz/api/';
  // static MBS_IMGPATH = 'https://api.prpsms.biz';



  //New
  // static MBS_APIACCOUNTMASTER = 'http://139.5.190.30/api/';
  // static MBS_APISMSMASTER = 'http://139.5.190.30/api/';
  // static MBS_APITRANSACTION = 'http://139.5.190.30/api/';
  // static MBS_IMGPATH = 'http://139.5.190.30';

  //testing 170225
  // static MBS_APIACCOUNTMASTER = 'http://139.5.190.30:8081/api/';
  // static MBS_APISMSMASTER = 'http://139.5.190.30:8081/api/';
  // static MBS_APITRANSACTION = 'http://139.5.190.30:8081/api/';
  // static MBS_IMGPATH = 'http://139.5.190.30';


  //   static MBS_APIACCOUNTMASTER = 'http://173.212.244.21:8032/api/';
  // static MBS_APISMSMASTER = 'http://173.212.244.21:8032/api/';
  // static MBS_APITRANSACTION = 'http://173.212.244.21:8032/api/';

  // static MBS_APIACCOUNTMASTER = 'http://173.212.244.21:8031/api/';
  // static MBS_APISMSMASTER = 'http://173.212.244.21:8031/api/';
  // static MBS_APITRANSACTION = 'http://173.212.244.21:8031/api/';

  // static MBS_APIACCOUNTMASTER = 'https://173.212.244.21:444/api/';
  // static MBS_APISMSMASTER = 'https://173.212.244.21:444/api/';
  // static MBS_APITRANSACTION = 'https://173.212.244.21:444/api/';




  // static MBS_APIACCOUNTMASTER = 'http://103.205.65.110:8080/mbs-account-master/';
  // static MBS_APISMSMASTER='http://103.205.65.110:8080/mbs-sms-master/';
  // static MBS_APITRANSACTION='http://103.205.65.110:8080/mbs-sms-transaction/';


  // static MBS_APIACCOUNTMASTER = 'http://ss.mpstechnologies.com/scholarlystats_alpha/services/';


  // static MBS_APIACCOUNTMASTER = 'http://10.50.8.220/scholarlystats_alpha/services/';
  // scholarlystats_alpha/services/
  // static THIRD = UrlConstants.MBS_APIACCOUNTMASTER + `platformReport/getPlatformSpecificReports`;

  // "COUNTER &
  // Custom Reports"	Reporting Period
  //       Get Available Reports
  //       Download Report
  //       Get Chart


  /* **************  USER DETAILS  *************** */
  static FORGETPASSWORD = UrlConstants.MBS_APIACCOUNTMASTER + 'Login/ForgotPassword';
  static URLRegister = UrlConstants.MBS_APIACCOUNTMASTER + 'user/RegisterUser';
  static URLRegisterCommonUser = UrlConstants.MBS_APIACCOUNTMASTER + 'user/RegisterCommonUser';
  static LOGIN = UrlConstants.MBS_APIACCOUNTMASTER + 'Login';
  static SERVICETYPE = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getservicetype';
  static ACCOUNTSERVICETYPE = UrlConstants.MBS_APIACCOUNTMASTER + 'account/getservicetype';
  static ACCOUNTS = UrlConstants.MBS_APIACCOUNTMASTER + 'account/getaccounts';



  static ROLEMENU = UrlConstants.MBS_APIACCOUNTMASTER + 'Role/getuserrolemenu';
  static ACCOUNTLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'user/GetAllUsers';
  // static ` ` UrlConstants.MBS_APIACCOUNTMASTER +'common/getaccounttype';
  static ACCOUNTMANAGER = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getaccountmanager';
  static GATEWAYLISTURL = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getGateWayList';

  static GETACCOUNTLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'user/GetAccountList';

  static BALANCESTATUS = UrlConstants.MBS_APIACCOUNTMASTER + 'BitCoin/GetbalanceStatus';
  static GETACCOUNTTYPELIST = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getaccounttypeList';
  static GETROLELIST = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getrolelist';
  static COUNTRY = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getcountry';
  static STATES = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getstates';
  static ACCOUNTINFOBYID = UrlConstants.MBS_APIACCOUNTMASTER + 'user/GetUserById';
  static ACCOUNTINFOADD = UrlConstants.MBS_APIACCOUNTMASTER + 'User/SaveUser';
  static ACCOUNTSTATUSCHANGE = UrlConstants.MBS_APIACCOUNTMASTER + 'User/StatusChangeUser';
  static PAYLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'common/GetPaymentList';
  static SMSCRTRLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getSmsCrTrDetails';
  static PAYSTATUS = UrlConstants.MBS_APIACCOUNTMASTER + 'BitCoin/Getpaymentstatus';

  static GROUPLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'common/GetGroupList';
  static GROUPCHANGESTATUS = UrlConstants.MBS_APIACCOUNTMASTER + 'common/Groupchangestatus';
  static GROUPADD = UrlConstants.MBS_APIACCOUNTMASTER + 'common/AddUpdateGroup';

  static DIRECTORYLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'common/GetPhoneList';
  static DIRECTORYBYID = UrlConstants.MBS_APIACCOUNTMASTER + 'common/GetPhoneById';
  static DIRECTORYADD = UrlConstants.MBS_APIACCOUNTMASTER + 'common/AddUpdatePhone';
  static DIRECTORYDELETE = UrlConstants.MBS_APIACCOUNTMASTER + 'common/StatusChangePhone';
  static DIRECTORYUPLOAD = UrlConstants.MBS_APIACCOUNTMASTER + 'accountdirectory/upload';
  static DIRECTORYREMOVE = UrlConstants.MBS_APIACCOUNTMASTER + 'accountdirectory/remove';
  static LANGUAGE = UrlConstants.MBS_APIACCOUNTMASTER + 'common/getlanguage';
  static PHONEBOOKLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'accountgroupdirectory/list';
  static PHONEBOOKGROUPDELETE = UrlConstants.MBS_APIACCOUNTMASTER + 'common/StatusChangePhoneGroup';

  static SENDERBYACCUNTAMDSERVICETYPE = UrlConstants.MBS_APISMSMASTER + 'sender/getbyaccountandservicetype';
  static SMSROUTETYPEBYSERVICETYPE = UrlConstants.MBS_APISMSMASTER + 'common/getsmsroutetypebyservicetype';


  //  static   SENDERLIST = UrlConstants.MBS_APILOCAL +'common/UserSenderIdGet';
  //  static   SENDERADD = UrlConstants.MBS_APILOCAL +'common/SmsSenderIdAddUpdate';
  //  static   SENDERCHANGESTATUS = UrlConstants.MBS_APILOCAL +'common/SenderIdStatusChange';

  static SENDERLIST = UrlConstants.MBS_APISMSMASTER + 'common/getusermasking';
  static GETSENDERLIST = UrlConstants.MBS_APISMSMASTER + 'common/getUserMaskingList';
  static SENDERADD = UrlConstants.MBS_APISMSMASTER + 'common/AddUpdateUserMasking';
  static SENDERBULKADD = UrlConstants.MBS_APISMSMASTER + 'common/SmsSenderIdBulkUpload';
  static SENDERCHANGESTATUS = UrlConstants.MBS_APISMSMASTER + 'common/changestatus';
  static SENDERBYSENDERID = UrlConstants.MBS_APISMSMASTER + 'common/getmaskingbyid';
  static SENDERUNIQUECHECK = UrlConstants.MBS_APISMSMASTER + 'common/maskingUniqueCheck'

  static ADDUSERGATEWAYCOUNTRYMAP = UrlConstants.MBS_APISMSMASTER + 'common/addUserGateWayMap';
  static ADDGATEWAY = UrlConstants.MBS_APISMSMASTER + 'common/addGateWay';
  static ADDGATEWAYCOUNTRYMAPPING = UrlConstants.MBS_APISMSMASTER + 'common/addsmscCountry';
  static USERGATEWAYCOUNTRYMAPPINGLIST = UrlConstants.MBS_APISMSMASTER + 'common/getUsersmscList';
  static GATEWAYCOUNTRYMAPPINGLIST = UrlConstants.MBS_APISMSMASTER + 'common/getsmscCountryList';

  static TEMPLATELIST = UrlConstants.MBS_APISMSMASTER + 'common/GetSMSTemplateLists';
  static TEMPLATELISTDDL = UrlConstants.MBS_APISMSMASTER + 'common/GetTemplateListDdl';
  static TEMPLATEADD = UrlConstants.MBS_APISMSMASTER + 'common/AddUpdateUserTemplate';
  static TEMPLATECHANGESTATUS = UrlConstants.MBS_APISMSMASTER + 'common/TemplateStatusChange';
  static TEMPLATEBULKADD = UrlConstants.MBS_APISMSMASTER + 'common/SmsTemplateBulkUpload';
  // static   TEMPLATELIST = UrlConstants.MBS_APILOCAL +'common/SmsTemplateGet';
  // static   TEMPLATEADD = UrlConstants.MBS_APILOCAL +'common/SmsTemplateAddUpdate';
  // static   TEMPLATECHANGESTATUS = UrlConstants.MBS_APILOCAL +'common/TemplateStatusChange';

  static GETBLACKLIST = UrlConstants.MBS_APISMSMASTER + 'common/GetBlackList';
  static ADDBLACKLIST = UrlConstants.MBS_APISMSMASTER + 'common/AddUpdateBlackList';
  static DELETEBLACKLIST = UrlConstants.MBS_APISMSMASTER + 'common/DeleteBlackList';

  static USERPRICELIST = UrlConstants.MBS_APISMSMASTER + 'common/GetUserPriceList';
  static WALLATELIST = UrlConstants.MBS_APISMSMASTER + 'common/getWalletList';

  static SMSTRANSACTIONALROUTETYPE = UrlConstants.MBS_APISMSMASTER + 'common/getsmstramsactonalroutetype';
  static SMSROUTE = UrlConstants.MBS_APISMSMASTER + 'common/getsmsroute';
  static SMSCONFIGBYACCOUNTANDSMSTYPE = UrlConstants.MBS_APISMSMASTER + 'smsconfig/getbyaccountandroutetype';
  static SMSCONFIGADD = UrlConstants.MBS_APISMSMASTER + 'smsconfig/add';
  static SMSBALANCEBYACCUNTAMDSERVICETYPE = UrlConstants.MBS_APISMSMASTER + 'common/smsbalance';
  static SMSBALANCEADD = UrlConstants.MBS_APISMSMASTER + 'common/addsmsbalance';


  static SENDSMSOMCHECK = UrlConstants.MBS_APISMSMASTER + 'SendSMS/sendom';
  static SENDSMSOM = UrlConstants.MBS_APITRANSACTION + 'SendSMS/sendom';
  static SENDSMSMMCHECK = UrlConstants.MBS_APISMSMASTER + 'SendSMS/sendmm';
  static SENDSMSMM = UrlConstants.MBS_APITRANSACTION + 'SendSMS/sendmm';

  static URLCAMAPAIGNREPORT = UrlConstants.MBS_APITRANSACTION + 'SmsMis/GetCampaignMIS';
  static URLDASHBOARDREPORT = UrlConstants.MBS_APITRANSACTION + 'SmsMis/getDashboarddata';

  static URLMESSAGEREPORT = UrlConstants.MBS_APITRANSACTION + 'SmsMis/GetMessageMIS';

  static URLREPLYREPORT = UrlConstants.MBS_APITRANSACTION + 'SmsMis/GetReplyMIS';

  static FUNDADD = UrlConstants.MBS_APITRANSACTION + 'BitCoin/bitreciever';
  static FUNDADDPAYPAL = UrlConstants.MBS_APITRANSACTION + 'PayapalPayment/createPayment';

  static EMAILVERIFICATIONCODE = UrlConstants.MBS_APITRANSACTION + 'user/EmailVerificationCode';
  static PHONEVERIFICATIONCODE = UrlConstants.MBS_APITRANSACTION + 'user/PhoneVerificationCode';
  static VERIFYEMAILOTP = UrlConstants.MBS_APITRANSACTION + 'user/VerifyEmailOTP';
  static VERIFYMOBILEOTP = UrlConstants.MBS_APITRANSACTION + 'user/VerifyPhoneOTP';
  static GENERATEAPIKEY = UrlConstants.MBS_APITRANSACTION + 'ApplicationKeys/GenerateKeys';
  static APIKEYDETAIL = UrlConstants.MBS_APITRANSACTION + 'ApplicationKeys/GetAPIKeysDetails';
  static APIKEYDeactivate = UrlConstants.MBS_APITRANSACTION + 'ApplicationKeys/DeactivateService';
  static APIKEYActivate = UrlConstants.MBS_APITRANSACTION + 'ApplicationKeys/ReActivateService';


  static GETMASKINGBYID = UrlConstants.MBS_APISMSMASTER + 'common/getmaskingbyid';
  static GETTEMPLATEBYID = UrlConstants.MBS_APISMSMASTER + 'common/getTemplatebyid';


  static GETCAMPIGNSCHEDULEDREPORT = UrlConstants.MBS_APISMSMASTER + 'common/getCampaignDeliveryReport';
  static GETCAMPAIGNDETAILS = UrlConstants.MBS_APISMSMASTER + 'common/getCampaignDetails';
  static GETDELIVERYREPORT = UrlConstants.MBS_APISMSMASTER + 'common/getDeliveryReport';
  static GETDELIVERYREPORTDETAILS = UrlConstants.MBS_APISMSMASTER + 'common/getDeliveryReportDetails';


  static ACCOUNTCRDRREPORT = UrlConstants.MBS_APISMSMASTER + 'common/GetPeriodicReport';

  static SMSCREPORTGET = UrlConstants.MBS_APISMSMASTER + 'common/GetSmscReport';


  static ADDUPDATEWHITELIST = UrlConstants.MBS_APISMSMASTER + 'common/AddUpdateWhitelist';
  static GETWHITELISTDATA = UrlConstants.MBS_APISMSMASTER + 'common/GetWhiteListing';


  static GETGATEWAYPROVIDERLIST = UrlConstants.MBS_APISMSMASTER + 'user/getGatewayProviderList';
  static ADDBULKGATEWAYTRANSFER = UrlConstants.MBS_APISMSMASTER + 'user/BulkGatewayTransfer';
  static GETUSERGATEWAYLIST = UrlConstants.MBS_APISMSMASTER + 'user/GetUserGatewayList';


  static GETACCOUNTHIERARCHY = UrlConstants.MBS_APISMSMASTER + 'common/GetAccountHierarchy';
  static GETUSERDETAILSASUSERIS = UrlConstants.MBS_APISMSMASTER + 'common/GetUserDetailsAsUserId';

  static GETUSERSCHEDULEDREPORT = UrlConstants.MBS_APISMSMASTER + 'common/GetScheduledReport'
  static SCHEDULEDCAMPAIGNCANCEL = UrlConstants.MBS_APISMSMASTER + 'common/CampaignScheduleCancel';

  static GETDELIVERYRPTDCRYPT = UrlConstants.MBS_APISMSMASTER + 'common/getDeliveryDetailsAsMsgId';

  static USERPROFILEUPDATE = UrlConstants.MBS_APIACCOUNTMASTER + 'user/UserProfileUpdate';
  static FORGOTPASSWORD = UrlConstants.MBS_APIACCOUNTMASTER + 'user/SendLoginCredMail';
  static UPLOADUSERLOGO = UrlConstants.MBS_APIACCOUNTMASTER + 'user/UserLogoUpload';

  static GETUSERDLRREPORTLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'common/GetUserDlrList';
  static GETUSERDLRFILE = UrlConstants.MBS_APIACCOUNTMASTER + 'common/DownloadDlrFile';
  static GENERATEUSERDLR = UrlConstants.MBS_APIACCOUNTMASTER + 'common/deliveryReportFileGenerate';

  //rcs apis
  // static GETUSERSERVICES = UrlConstants.MBS_APIACCOUNTMASTER + 'rcscommon/GetUserServices';
  //http://139.5.190.30:9095/api/rcscommon/GetUserServices (AI-CHATBOT)
  static GETUSERSERVICES = UrlConstants.MBS_APIACCOUNTMASTER + 'rcscommon/GetUserServices';

  static RCSTEMPLATEADDUPDATE = UrlConstants.MBS_APIACCOUNTMASTER + 'rcscommon/AddUpdateStandAloneTemplate';
  static GETRCSTEMPLATELIST = UrlConstants.MBS_APIACCOUNTMASTER + 'rcscommon/GetRCSTemplateList';
  static RCSTEMPLATESTATUSCHANGE = UrlConstants.MBS_APIACCOUNTMASTER + 'rcscommon/RCSTemplateStatusChange';
  static GETDDLTEMPLATELIST = UrlConstants.MBS_APIACCOUNTMASTER + 'rcscommon/GetDDLTemplateList';


  static SENDRCSOM = UrlConstants.MBS_APIACCOUNTMASTER + "sendRCS/sendRCS";
  static SENDRCSDYNAMIC = UrlConstants.MBS_APIACCOUNTMASTER + "sendRCS/sendDynamicRCS";

  static ADDAGENT = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/AddRcsAgentBot";
  static GETAGENTLIST = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/GetAgentList";
  static AGENTSTATUSCHANGE = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/AgentStatusChange";

  static ADDRCSBALANCE = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/addRCSbalance";
  static ADDRCSBALANCERATEWISE = UrlConstants.MBS_APIACCOUNTMASTER + "RCSCommon/addRCSbalanceRatewise";

  static ADDRCSRATE = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/RscAddRate";
  static GETRCSRATELIST = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/GetRCSRateList";
  static GETAGENTLISTDDL = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/GetAgentListDDL";

  static GETRCSDELIVERYREPORT = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/GetRcsDeliveryReport";
  static GETRCSDELIVERYREPORTDETAILS = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/GetRcsDeliveryReportDetails";
  static GETRCSDELIVERYREPORTSPLITTER = UrlConstants.MBS_APIACCOUNTMASTER + "RCSCommon/deliveryReportFileGenerate"
  static RCSDELIVERYSPLITTERREPORT = UrlConstants.MBS_APIACCOUNTMASTER + 'common/GetUserDlrList'


  static SENDRCS = UrlConstants.MBS_APIACCOUNTMASTER + "sendRCS/sendRCS";

  static GETRCSBALANCE = UrlConstants.MBS_APIACCOUNTMASTER + "rcscommon/GetRCSBalance";
  static GETRCSBALANCERATEWISE = UrlConstants.MBS_APIACCOUNTMASTER + "RCSCommon/GetRatewiseRCSBalance"

  static ADDCOMMONUSER = UrlConstants.MBS_APIACCOUNTMASTER + 'User/CommanUserRegister';
  static COMMONUSERDETAILSBYID = UrlConstants.MBS_APIACCOUNTMASTER + 'user/CommonUserDetailsById';


  //  SMPP

  static GETSMPPUSERS = UrlConstants.MBS_APIACCOUNTMASTER + 'user/GetSMPPUsers';
  static ADDSMPPUSER = UrlConstants.MBS_APIACCOUNTMASTER + 'user/saveSMPPUsersConfig';

  static GETSMPPDLRDETAILS = UrlConstants.MBS_APISMSMASTER + 'common/getSMPPDeliveryReportDetails';
  static GETSMPPDLR = UrlConstants.MBS_APISMSMASTER + 'common/getSMPPDeliveryReport';


  // rcs
  static RCSPERIODICREPORT = UrlConstants.MBS_APIACCOUNTMASTER + 'rCSCommon/GetRCSPeriodicReport';
  static GETRCSCAMPAIGNREPORT = UrlConstants.MBS_APISMSMASTER + 'rCSCommon/getRCSCampaignReport';
  static GETRCSCAMPAIGNREPORTDETAILS = UrlConstants.MBS_APISMSMASTER + 'rCSCommon/getRCSCampaignDetails';

  static GETDASHBOARDDATA = UrlConstants.MBS_APISMSMASTER + 'rCSCommon/getdashboarddata';

       // AICHATBOT
        //  'https://testaiapi.chatmybot.in/api/User/RegisterUser',
 static GETRESGISTERUSER = UrlConstants.MBS_APIACCOUNTMASTER +'User/RegisterUser';

static GETUSERACCOUTLIST = UrlConstants.MBS_APIACCOUNTMASTER + 'user/GetAccountList';
static GETCHATBOT = UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/GetChatBots';
static GETALLCHATBOTBYUSER = UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/GetAllChatBotsByUser';

static GETCONVERSATIONHISTORY = UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/GetConversationHistory';
static GETAICHATBOTSMSBALANCE = UrlConstants.MBS_APIACCOUNTMASTER + 'common/smsbalance';


static getdownloadapi = UrlConstants.MBS_APIACCOUNTMASTER+ 'chatbot/CustomerDataDownloads'



static GETADDSMSBALANCE = UrlConstants.MBS_APIACCOUNTMASTER + 'Common/addsmsbalance';
static GETUSERROLEMENU = UrlConstants.MBS_APIACCOUNTMASTER + 'Role/getuserrolemenu';
static GETUPDATEPROMPT = UrlConstants.MBS_APIACCOUNTMASTER + 'chatbot/UpdatePrompt';

static GETCREATECHATBOT = UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/CreateChatBot';
static GETPERIODICREPORT = UrlConstants.MBS_APIACCOUNTMASTER + 'common/GetPeriodicReport';

static GETDASHBOARDSUMMARY = UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/GetDashboardSummary';
 
static GETCUSTOMERDATA = UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/GetCustomerData';
static GETDATACUSTOMER = UrlConstants.MBS_APIACCOUNTMASTER + 'chatbot/customerdata';
static UPDATECUSTOMERDATA = UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/UpdateCustomerBotData';

static GETAPIKEYDETAILS = UrlConstants.MBS_APIACCOUNTMASTER + 'ApplicationKeys/GetAPIKeysDetails';
static GETGENERATEKEY = UrlConstants.MBS_APIACCOUNTMASTER + 'ApplicationKeys/GenerateKeys';
static GETREACTIVESERVICE = UrlConstants.MBS_APIACCOUNTMASTER + 'ApplicationKeys/ReActivateService';
static GETDEACTIVESERVICE = UrlConstants.MBS_APIACCOUNTMASTER + 'ApplicationKeys/DeactivateService';
  static BASE_URL: string;
  static GETCHATBOTLISTBYACCOUNT =  UrlConstants.MBS_APIACCOUNTMASTER + 'ChatBot/GetChatBots';
  static GETGENERATESCRIPTTAG = UrlConstants.MBS_APIACCOUNTMASTER +'chatbot/GenerateScriptTag';
  static GETUSERPROFILEUPDATE = UrlConstants.MBS_APIACCOUNTMASTER +'user/UserProfileUpdate';

  // Dynamic bot
// static DYNAMICBOT = 'http://156.67.25.89:5005';
static DYNAMICBOT = 'https://dynamic.chatmybot.in';
  static SAVE_FLOW_ENDPOINT = UrlConstants.DYNAMICBOT + '/save-flow';
static LIST_CHATBOTS_ENDPOINT = UrlConstants.DYNAMICBOT + '/list-chatbots';
static GET_ALL_LIST_CHATBOT_ENDPOINT = UrlConstants.DYNAMICBOT + '/get-flow';
static GET_UPDATE_CHATBOT_ENDPOINT = UrlConstants.DYNAMICBOT + '/update-flow';
  static SAVE_BOT_SCRIPT: any;
  static CREATEBOT: any;
}



//update profile 
//http://testaiapi.chatmybot.in/api/user/UserProfileUpdate

// AICHATBOT
     //'http://139.5.190.30:8084/api/chatbot/GenerateScriptTag',   // SCRIPT KEY
                 //account configuration API:-
//'http://139.5.190.30:8084/api/user/GetAccountList',  //account list

                 // Ai-conversation-history :-
//'http://139.5.190.30:8084/api/user/GetAccountList',
// `http://139.5.190.30:8084/api/ChatBot/GetAllChatBotsByUser?userid=${userId}`,true   //ON ACCOUNT CHNAGE
//  'http://139.5.190.30:8084/api/ChatBot/GetConversationHistory', //CONVERSATION HISTROY
// 'http://139.5.190.30:8084/api/ChatBot/GetChatBots',  //Get chatbot

                    //AI-creditdebit:-
//"http://139.5.190.30:8084/api/common/smsbalance"    //smsbalance
//'http://139.5.190.30:8084/api/user/GetAccountList';  //Get accountlist
// 'http://139.5.190.30:8084/api/common/smsbalance',    //sms balance
//"http://139.5.190.30:8084/api/Common/addsmsbalance",  //addsmsbalance

                  //Ai chatbot home:-
//'http://139.5.190.30:8084/api/Role/getuserrolemenu';   //Get user rolemenu

                  // Bot creation:-
// 'http://139.5.190.30:8084/api/ChatBot/GetChatBots',   //Get chatbot
//  'http://139.5.190.30:8084/api/user/GetAccountList',  //Get accountlist
//  `http://139.5.190.30:8084/api/ChatBot/GetAllChatBotsByUser?userid=${userId}`,true    //account change
// "http://139.5.190.30:8084/api/chatbot/UpdatePrompt",    //update prompt
//"http://139.5.190.30:8084/api/ChatBot/CreateChatBot"      //create chatbot

                  // Data Upload:-
//'http://139.5.190.30:8084/api/ChatBot/GetCustomerData';  // Get customer data
// 'http://139.5.190.30:8084/api/ChatBot/GetChatBots',     //Get chatbot
// 'http://139.5.190.30:8084/api/user/GetAccountList',     //Get accountlist
// `http://139.5.190.30:8084/api/ChatBot/GetAllChatBotsByUser?userid=${userId}`,true    //account change
// 'http://139.5.190.30:8084/api/chatbot/customerdata';    //customer data
// 'http://139.5.190.30:8084/api/ChatBot/UpdateCustomerBotData';    //update customer bot data

                 //API Key 
//'http://139.5.190.30:8084/api/ApplicationKeys/GetAPIKeysDetails',    //Get API KEY DETAILS
// 'http://139.5.190.30:8084/api/ApplicationKeys/GenerateKeys',        // Generate Keys
//'http://139.5.190.30:8084/api/ApplicationKeys/ReActivateService'     //Reactive services 
//'http://139.5.190.30:8084/api/ApplicationKeys/DeactivateService';    //deactive service

                // Periodic details (credit-debit details):-
  // "http://139.5.190.30:8084/api/common/GetPeriodicReport";     // Periodic report 
  // "http://139.5.190.30:8084/api/user/GetAccountList";          //Get account list
  
               // Dashboard :-
  //"http://139.5.190.30:8084/api/ChatBot/GetDashboardSummary",        
  

         